module.exports = __webpack_public_path__ + "static/media/playercontrols.50b8af17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/elements/screen-images/music/playercontrols.jpg
// module id = 712
// module chunks = 0